import axios from '../clients/rdn';

export const searchDictionaryFor = (query: string) =>
  axios.get(`/v2/dictionary/search/${query}`);
